import { ApiModule, type PaginatedResponseData } from '@common/index';
import type { PersonHasEducationElementItem, PersonHasEducationElement } from '../models';

export class PersonHasEducationElementApi extends ApiModule {
  protected endpoint = '/person-has-education-element';

  public async pagePersonHasEducationElements(params: any) {
    return this.api.post<PaginatedResponseData<PersonHasEducationElementItem>, any>(
      `${this.endpoint}/page?page=${params.page}&size=${params.itemsPerPage}&sort=${params.sort ?? ''}&sort=${params.sort ?? ''}`,
      {
        ...params
      }
    );
  }

  public loadPersonHasEducationElementDetails(id: number) {
    return this.api.get<PersonHasEducationElement>(`${this.endpoint}?id=${id}`);
  }

  public savePersonHasEducationElement(params: any) {
    return this.api.post(`${this.endpoint}`, {
      ...params
    });
  }

  public deletePersonHasEducationElement(id: number) {
    return this.api.delete(`${this.endpoint}?id=${id}`);
  }
}
